import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, LoginResult } from 'src/app/services/common/authentication.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  loginFG!: FormGroup;
  emailFC!: FormControl<string | null>;
  passwordFC!: FormControl<string | null>;

  showPassword:boolean = false;

  isLoading:boolean = false;

  constructor(
    private authenticationService:AuthenticationService,
    private snackBar:MatSnackBar,
    private route:ActivatedRoute,
    private router:Router,
    private location:Location
  ) { }

  ngOnInit(): void {
    this.emailFC = new FormControl<string | null>("");
    this.passwordFC = new FormControl<string | null>("");

    this.loginFG = new FormGroup({
      emailFC: this.emailFC,
      passwordFC: this.passwordFC
    });

    this.prefillCredentialsFromQueryParams();
    this.removeCredentialsFromQueryParams();
  }


  public prefillCredentialsFromQueryParams(){
    const queryParams = this.route.snapshot.queryParams;
    if(queryParams.email && queryParams.password) {
      this.emailFC.setValue(queryParams.email);
      this.passwordFC.setValue(queryParams.password);
    }
  }

  public removeCredentialsFromQueryParams(){
    const url = this.router.url;
    const urlTree = this.router.parseUrl(url);

    // Create a mutable copy of the queryParams
    const queryParams = { ...urlTree.queryParams };

    // Remove email and password parameters
    delete queryParams['email'];
    delete queryParams['password'];

    // Update the queryParams in the urlTree
    urlTree.queryParams = queryParams;

    // Update the browser's URL without navigation
    this.location.replaceState(urlTree.toString());
  }

  public async login():Promise<void> {
    if(this.loginFG.invalid) {
      return;
    }

    this.isLoading = true;

    const loginEmail:string = (this.emailFC.value ?? "").trim();

    try {
      const loginResult:LoginResult = await this.authenticationService.login(loginEmail, this.passwordFC.value ?? "");
      switch(loginResult) {
      case LoginResult.WrongCredentials:
        this.snackBar.open("Hibás felhasználónév vagy jelszó.", "Bezár", { duration: 3000 });
        break;
      case LoginResult.ServerError:
        this.snackBar.open("Hiba történt bejelentkezés közben.", "Bezár", { duration: 3000 });
        break;
      case LoginResult.ServerConnectionError:
          this.snackBar.open("Hiba a szerverkapcsolatban.", "Bezár", { duration: 3000 });
          break;
      }
    } catch (error) {
      this.snackBar.open("Hiba történt bejelentkezés közben.", "Bezár", { duration: 3000 });
    }finally{
      this.isLoading = false;
    }
  }
}
